import React from 'react';
import { Link } from 'react-router-dom';
import Spline from '@splinetool/react-spline';
import { TrendingUp, Ship, Award, ArrowRight, Download } from 'lucide-react';
import { services, stats } from '../mockData';
import GlobalReachMap from '../components/GlobalReachMap';

const Home = () => {
  const iconMap = {
    TrendingUp,
    Ship,
    Award
  };

  return (
    <div className="page-container">
      {/* Hero Section with Spline */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="display-huge">
              Premium Bauxite Trading from Guinea to the World
            </h1>
            <p className="body-large hero-description">
              Connecting premium bauxite reserves with global aluminum producers. Reliable supply chains from Guinea to Asia, Middle East, and Europe.
            </p>
            <div className="hero-cta">
              <Link to="/contact" className="btn-primary">
                Request a Quote
                <ArrowRight size={20} />
              </Link>
              <Link to="/services" className="btn-secondary">
                Our Services
              </Link>
            </div>
            <div className="hero-stats">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-spline">
            <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-section">
        <div className="section-header">
          <h2 className="display-medium">Our Services</h2>
          <p className="body-medium section-subtitle">
            Comprehensive bauxite trading and consulting solutions
          </p>
        </div>
        <div className="services-grid">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="heading-2">{service.title}</h3>
                <p className="body-medium">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="body-small">{feature}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="section-cta">
          <Link to="/services" className="btn-primary">
            Explore All Services
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Geographic Reach */}
      <section className="regions-section">
        <div className="section-header">
          <h2 className="display-medium">Global Reach</h2>
          <p className="body-medium section-subtitle">
            Connecting Guinea's premium bauxite with markets worldwide
          </p>
        </div>
        <GlobalReachMap />
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="display-large">Ready to Get Started?</h2>
          <p className="body-large">
            Get in touch with our team to discuss your bauxite requirements and receive a competitive quote.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary">
              Get a Quote
              <ArrowRight size={20} />
            </Link>
            <Link to="/resources" className="btn-secondary">
              <Download size={20} />
              Download Brochure
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;